'use client';

import React from 'react';
import { MAX_QUANTITY_PER_PRODUCT } from '@/lib/products';
import { useI18n } from '@/i18n/LocaleProvider';

interface QuantityStepperProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
}

export default function QuantityStepper({ value, onChange, min = 1 }: QuantityStepperProps) {
  const { t } = useI18n();
  const buttonClass =
    'w-8 h-8 flex items-center justify-center rounded-full text-muted-foreground hover:text-foreground disabled:opacity-30 disabled:cursor-not-allowed transition-colors';

  return (
    <div className="inline-flex items-center rounded-full border border-border glass-card">
      <button type="button" className={buttonClass} onClick={() => onChange(value - 1)} disabled={value <= min} aria-label={t.cart.decrease}>
        −
      </button>
      <span className="w-7 text-center text-sm font-semibold text-foreground tabular-nums" aria-live="polite">
        {value}
      </span>
      <button
        type="button"
        className={buttonClass}
        onClick={() => onChange(value + 1)}
        disabled={value >= MAX_QUANTITY_PER_PRODUCT}
        aria-label={t.cart.increase}
      >
        +
      </button>
    </div>
  );
}
